module.exports = __webpack_public_path__ + "img/map-rocky.950f6c35.webp";